import { connect } from 'react-redux';

import { State } from '../../../reducer';
import OrderPage from '../components/OrderPage';
import { getOrder, createComment, deleteComment, getUsers } from '../actions';
import { openAuthorize } from '../../authorizeOrder/actions';
import { openCapture } from '../../captureOrder/actions';
import { openRefund } from '../../refundOrder/actions';
import { openCancel } from '../../cancelOrder/actions';
import {
    getOrderSelector,
    getIsLoadingSelector,
    getIsNotFoundSelector,
    getCreateCommentIsLoadingSelector,
    getUsersSelector
} from '../selectors';

const mapStateToProps = (state: State) => ({
    order: getOrderSelector(state),
    users: getUsersSelector(state),
    isLoading: getIsLoadingSelector(state),
    createCommentIsLoading: getCreateCommentIsLoadingSelector(state),
    isNotFound: getIsNotFoundSelector(state),
});

const mapDispatchToProps = {
    getOrder,
    openAuthorize,
    openCapture,
    openRefund,
    openCancel,
    createComment,
    deleteComment,
    getUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderPage);
